import Trash from './trash';

export * from './trash';
export default Trash;
